import * as React from 'react';
import {styled, styledDiv} from '@packages/utilities/styled';
import {FlowWrench, FlowStatusWarning12} from '@packages/systems/ui/icons';
import TooltipTrigger from '@packages/systems/design-system/TooltipTrigger';

const FlowWrenchIcon = styled(FlowWrench)({
  borderRadius: '50%',
});

const StyledStatusIcon = styledDiv(({theme: {colors, gutters}}) => ({
  width: gutters.x12,
  height: gutters.x12,
  display: 'flex',
  alignItems: 'center',
  justifyItems: 'center',
  borderRadius: '50%',
  backgroundColor: colors.logicFlows.statusIconBackground,
  color: colors.warning,
}));

export const HasHolesIcon = () => (
  <TooltipTrigger
    placement="top"
    alternate
    content="This variable requires a fallback"
  >
    <StyledStatusIcon>
      <FlowWrenchIcon />
    </StyledStatusIcon>
  </TooltipTrigger>
);

export const HasMissingSourcesIcon = () => (
  <TooltipTrigger
    placement="top"
    alternate
    content="There is no source for this binding"
  >
    <StyledStatusIcon>
      <FlowStatusWarning12 />
    </StyledStatusIcon>
  </TooltipTrigger>
);

export const HasErrorsIcon = () => (
  <TooltipTrigger
    placement="top"
    alternate
    content="This binding is invalid and should be replaced"
  >
    <StyledStatusIcon>
      <FlowStatusWarning12 />
    </StyledStatusIcon>
  </TooltipTrigger>
);
